import { Provider } from '@angular/core';
import { provideStreamingPromptResponseInterceptor } from '@panaya/ai-chat/domain';
import { CANVAS_CONTENT_CONTRIBUTOR, CANVAS_RESETTABLES, provideCanvasDisplay } from '@panaya/ai-chat/features';
import { AI_CHAT_LOG_FOOTER_COMPONENT } from '@panaya/ai-chat/ui';
import { CollectionDisplayComponent } from './displays/collection-display/collection-display.component';
import { DraftCardComponent } from './draft-card/draft-card.component';
import { DraftContentContributor } from './draft-content.contributor';
import { createDraftInterceptor } from './draft.interceptor';
import { DraftStore } from './draft.store';

/**
 * The draft display family: the draft interceptor, the `collection` display, the frame's content hook, the draft card
 * in the chat log, and the draft store's reset on a thread change and on a new canvas. A tool whose display type is
 * not `collection` has no registered display, so the frame does not open a canvas for it.
 *
 * List it after `provideCanvasFrame()`: interceptors run in the order they are provided, and the draft interceptor
 * must run after the frame interceptor, which opens and clears the canvas first.
 */
export function provideCanvasDraft(): Provider[] {
    return [
        provideStreamingPromptResponseInterceptor(createDraftInterceptor),
        provideCanvasDisplay('collection', CollectionDisplayComponent),
        { provide: CANVAS_CONTENT_CONTRIBUTOR, useExisting: DraftContentContributor },
        { provide: CANVAS_RESETTABLES, useExisting: DraftStore, multi: true },
        { provide: AI_CHAT_LOG_FOOTER_COMPONENT, useValue: DraftCardComponent }
    ];
}
